import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { sdk } from '@/services';

const StudentQuizService = sdk.getService('StudentQuizService');

export const useStudentQuizDetail = () => {
  const { _id } = useParams<{ _id: string }>();

  const { data, isLoading } = useQuery({
    queryKey: ['student-quiz', _id],
    queryFn: () => StudentQuizService.getStudentQuiz(_id!),
    enabled: !!_id
  });

  return { studentQuiz: data, isLoading };
};
